var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.is_loading
    ? _c("div", [
        _c("h1", [_vm._v("Calendar")]),
        _vm._v(" "),
        _vm.is_premium
          ? _c("div", [
              _vm._m(0),
              _vm._v(" "),
              _c("iframe", {
                staticStyle: {
                  border: "0",
                  "max-width": "1200px",
                  height: "700px",
                },
                attrs: {
                  width: "100%",
                  height: "700",
                  border: "0",
                  frameborder: "0",
                  src: "https://calendly.com/d/cmk9-gzb-rj5/platform-call-with-proptecham-ai",
                },
              }),
            ])
          : _c("div", [
              _vm._m(1),
              _vm._v(" "),
              _c("iframe", {
                staticStyle: {
                  border: "0",
                  "max-width": "1200px",
                  height: "700px",
                },
                attrs: {
                  width: "100%",
                  height: "700",
                  border: "0",
                  frameborder: "0",
                  src: "https://calendly.com/d/cmk9-gzb-rj5/platform-call-with-proptecham-ai",
                },
              }),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Need some help navigating our platform?"),
      _c("br"),
      _vm._v("Book a slot here and I will guide you through!"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "In order to become a premium client and raise capital, we would like to have an introductory call with you. "
      ),
      _c("br"),
      _vm._v(
        "Please select a suitable time slot in our calendar to book a call with us!"
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }